import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    actionsColumnKey,
    bonusReportKey,
    bpiStatusColumnKey,
    closedPositionKey,
    cptLessonsKey,
    cptProductKey,
    initiatedColumnKey,
    initiatedKey,
    lastCheckPointColumnKey,
    lastCloseColumnKey,
    marketRelativeStrengthColumnKey,
    modelPortfolioKey,
    openedPositionKey,
    openPositionsTitle,
    peerRelativeStrengthColumnKey,
    sectorColumnKey,
    sectorRelativeStrengthColumnKey,
    stanceColumnKey,
    // stockReplacementStrategyCalculatorKey,
    symbolColumnKey,
    tradeAlertKey,
    webinarKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = modelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: cptProductKey,
    modelPortfolioKeys: [
        {
            key: openedPositionKey,
            title: openPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                stanceColumnKey,
                sectorColumnKey,
                lastCloseColumnKey,
                bpiStatusColumnKey,
                sectorRelativeStrengthColumnKey,
                peerRelativeStrengthColumnKey,
                marketRelativeStrengthColumnKey,
                initiatedColumnKey,
                lastCheckPointColumnKey,
                actionsColumnKey
            ]
        }
    ]
}

const productActionTopicKeys = [
    bonusReportKey,
    modelPortfolioKey,
    tradeAlertKey,
    webinarKey,
    // stockReplacementStrategyCalculatorKey,
    cptLessonsKey
];

export function useCheckPointTrader() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( cptProductKey, productActionTopicKeys );

    const portfolioActionsMap =
        configureProductPortfolioActionsMap(
            'CPT', initiatedKey, closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ], null );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
